import { useCallback } from 'react'
import { useSelector } from 'react-redux'

import { ERROR_ARCHIVE_CAMPAIGN_SERVER } from '@/app/module/campaigns/definitions'
import { createNotification } from '@/app/module/notifications/store/actions'
import { selectOrgId } from '@/app/module/user/store/selectors'
import { esApi, getErrorMessage } from '@/app/store/api'
import { useAppDispatch } from '@/app/store/redux-hooks'

type SetCampaignArchivedPayload = {
  archived: boolean
  campaignId: number
}

export const useSetCampaignArchived = () => {
  const dispatch = useAppDispatch()
  const orgId = useSelector(selectOrgId)
  const [setArchived, res] = esApi.endpoints.setCampaignArchived.useMutation()

  const setCampaignArchived = useCallback(
    async ({ archived, campaignId }: SetCampaignArchivedPayload) => {
      try {
        await setArchived({
          orgId: String(orgId),
          campaignId: String(campaignId),
          body: { archived },
        }).unwrap()

        dispatch(
          createNotification({
            'archive-campaign': {
              type: 'success',
              message: archived ? 'Campaign archived successfully.' : 'Campaign unarchived successfully.',
            },
          }),
        )

        return { id: Number(campaignId), archived }
      } catch (error) {
        dispatch(
          createNotification({
            'archive-campaign': {
              type: 'error',
              message: getErrorMessage(error, ERROR_ARCHIVE_CAMPAIGN_SERVER),
            },
          }),
        )
        return undefined
      }
    },
    [dispatch, orgId, setArchived],
  )

  return [setCampaignArchived, res] as const
}
